import * as React from 'react';
import * as classNames from 'classnames';
import { observer } from 'mobx-react';
import { SignUpToFavouritePrompt } from './SignUpToFavouritePrompt';
import { VideoAction } from './VideoAction';
import { Video } from '../../../../models';
const downloadIconURL = require('../../../../icons/download.svg');
const favouriteIconURL = require('../../../../icons/favourites.svg');
const shareIconURL = require('../../../../icons/share.svg');
import './style.css';

export interface VideoActionsProps {
  getVideoUrl: (video: Video) => string;
  loggedIn: boolean;
  onFavourite: () => void;
  savingFavourite: boolean;
  video: Video;
}

export interface VideoActionsState {
  showSignUpToFavouritePrompt: boolean;
}

@observer
export class VideoActions extends React.Component<
  VideoActionsProps,
  VideoActionsState
> {
  constructor(props: VideoActionsProps) {
    super(props);

    this.state = {
      showSignUpToFavouritePrompt: false
    };
  }

  render() {
    const {
      getVideoUrl,
      loggedIn,
      onFavourite,
      savingFavourite,
      video
    } = this.props;
    const { showSignUpToFavouritePrompt } = this.state;

    const favouriteClassNames = classNames({
      'video-action-favourite': true,
      'video-action-favourite-favourited': loggedIn && video.favourite,
      'video-action-favourite-updating': savingFavourite
    });

    let favouriteLabel;
    if (loggedIn && video.favourite) {
      if (savingFavourite) {
        favouriteLabel = 'Removing Favourite...';
      } else {
        favouriteLabel = 'Remove from Favourites';
      }
    } else {
      if (savingFavourite) {
        favouriteLabel = 'Adding Favourite...';
      } else {
        favouriteLabel = 'Add to Favourites';
      }
    }

    return (
      <ul className="video-actions">
        <VideoAction
          className={favouriteClassNames}
          linkHref="#"
          iconURL={favouriteIconURL}
          label={favouriteLabel}
          onClick={event => {
            event.preventDefault();

            if (loggedIn) {
              onFavourite();
            } else {
              this.setState({ showSignUpToFavouritePrompt: true });
            }
          }}
        >
          {showSignUpToFavouritePrompt ? (
            <div className="sign-up-to-favourite-prompt-wrapper">
              <SignUpToFavouritePrompt
                onClose={() =>
                  this.setState({ showSignUpToFavouritePrompt: false })
                }
              />
            </div>
          ) : null}
        </VideoAction>
        <VideoAction
          linkHref={`${getVideoUrl(video)}/share`}
          iconURL={shareIconURL}
          label="Share To..."
        />
        {video.attachment ? (
          <VideoAction
            isExternal={true}
            linkHref={video.attachment}
            linkTarget="_blank"
            iconURL={downloadIconURL}
            label="Download PDF"
          />
        ) : null}
      </ul>
    );
  }
}

export default VideoActions;



// WEBPACK FOOTER //
// ./src/app/components/Video/VideoDetailsBar/VideoActions/index.tsx